import React from "react";
import PropTypes from "prop-types";
import TutorialStepText from "./TutorialStepText";
import TutorialStepTextPrice from "./TutorialStepTextPrice";
import TutorialStepNumberedlist from "./TutorialStepNumberedList";

const TutorialElements = ({element, elementProps}) => {
    const getElement = (e) => {
        switch (e?.type) {
            case "tutorial_step_text":
                return (
                    <TutorialStepText 
                        componentId={e?.sys?.id} 
                        {...elementProps}
                    />
                );
            case "tutorial_step_text_price":
                return (
                    <TutorialStepTextPrice 
                        componentId={e?.sys?.id}
                        {...elementProps}
                    />
                );
            case "tutorial_step_numberedlist":
                return (
                    <TutorialStepNumberedlist 
                        componentId={e?.sys?.id} 
                        {...elementProps}
                    />
                );
            default:
                return <div/>;
        }
    };

    return getElement(element);
};

TutorialElements.propTypes = {
    element: PropTypes.object,
    elementProps: PropTypes.any
};

export default TutorialElements;
